import Vue from "vue";
import axios from "axios";
import "../../../../filters";
import moment from "moment";

export default {
  name: "SelectProperty",
  components: {
    DataGridComp: require("../../../../customcontrols/datagrid.vue").default,
    filterDataComp: require("../../../../customcontrols/filterData.vue")
      .default,
  },
  props: {
    dataObj: {
      type: Object,
      required: true,
    },
    isOffline: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      appId: -1,
      keyColumn: "propertyId",
      properties: [],
      options: { pageSize: 10, total: 0, page: 1 },
      totalRow: 0,
      propertiesCols: [],
      noDataFound: false,
      filterObj: [],
      property: {},
    };
  },
  computed: {
    showSelectedPanel: function () {
      return (
        this.dataObj &&
        this.dataObj.property &&
        this.dataObj.property.propertyId &&
        this.dataObj.property.propertyReference
      );
    },
  },
  created() {
    this.$root.$on("select_property_updated", this.init);
    this.fillPropertiesCols();
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
        this.fillFiltersObj();
      });
    },
    pageChange(pInfo) {
      if (
        this.options.page == pInfo.pageNumber &&
        this.options.pageSize == pInfo.pageSize
      )
        return;

      this.options.page = pInfo.pageNumber;
      this.options.pageSize = pInfo.pageSize;
      this.getProperties();
    },
    getProperties() {
      if (this.isOffline) {
        this.properties =
          this.$store.state.offlineApplicationsData.activityLookups[
            this.dataObj.appKey
          ]["properties"];
        this.options.total = this.properties.length;
        this.totalRow = 0;
      } else {
        var criteria = {};

        for (var i = 0; i < this.filterObj.filter((a) => a.added).length; i++) {
          criteria[this.filterObj.filter((a) => a.added)[i].field] =
            this.filterObj.filter((a) => a.added)[i].value;
        }

        var parameter = {
          ApplicationId: this.appId,
          ApplicationKey: 0,
          Filters: criteria,
          Options: this.options,
        };

        this.$store.state.notifier.asyncBlock(
          axios.post(
            "/SelectPropertyActivity/GetActivityProperties",
            parameter
          ),
          (response) => {
            if (response.status == 200) {
              if (response.data.items.length == 0) {
                this.properties = [];
                this.noDataFound = true;
              } else {
                this.properties = response.data.items;
                this.options.total = response.data.itemsCount;
                this.totalRow = response.data.itemsCount;

                if (this.properties.length == 1) {
                  this.property.townId = this.properties[0].townId;
                  this.property.townStr = this.properties[0].townStr;
                  this.property.townshipId = this.properties[0].townshipId;
                  this.property.townshipStr = this.properties[0].townshipStr;
                  this.property.propertyId = this.properties[0].propertyId;
                  this.property.propertyAddress =
                    this.properties[0].propertyAddress;
                  this.property.propertyBuldingName =
                    this.properties[0].propertyBuldingName;
                  this.property.propertyReference =
                    this.properties[0].propertyReference;
                  this.property.propertyOldKey =
                    this.properties[0].propertyOldKey;
                  this.property.propertyPlotNumber =
                    this.properties[0].propertyPlotNumber;
                  this.property.tenantCustomerKey =
                    this.properties[0].tenantCustomerKey;
                  this.property.tenantName = this.properties[0].tenantName;
                  this.property.tenantIdNumber =
                    this.properties[0].tenantIdNumber;
                  this.property.tenantTelephoneNumber =
                    this.properties[0].tenantTelephoneNumber;
                  this.property.tenantCellPhoneNumber =
                    this.properties[0].tenantCellPhoneNumber;
                  this.property.propertyOwnerCustomerKey =
                    this.properties[0].propertyOwnerCustomerKey;
                  this.property.propertyOwnerName =
                    this.properties[0].propertyOwnerName;
                  this.property.propertyOwnerIdNumber =
                    this.properties[0].propertyOwnerIdNumber;
                  this.property.propertyOwnerTelephoneNumber =
                    this.properties[0].propertyOwnerTelephoneNumber;
                  this.property.propertyOwnerCellPhoneNumber =
                    this.properties[0].propertyOwnerCellPhoneNumber;
                  this.property.ownerShare = this.properties[0].ownerShare;
                }
              }
              this.$root.$emit("datagrid_updated");
            } else this.$alertMsg(response.data.data.text);
          },
          (err) =>
            err.data == undefined
              ? this.$alertMsg(
                  `${this.$t("messages.apiRespondedWithCode")} ${
                    err.response.status
                  }`
                )
              : this.$alertMsg(err.data.data.text)
        );

        //let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
        //axios.post('/SelectPropertyActivity/GetProperties', parameter)
        //  .then(response => {
        //    if (response.status == 200) {
        //      console.log(response.data);

        //      if (response.data.items.length == 0) {
        //        this.properties = [];
        //        this.noDataFound = true;
        //      }
        //      else {
        //        this.properties = response.data.items;
        //        this.options.total = response.data.itemsCount;
        //        this.totalRow = response.data.itemsCount;

        //        if (this.properties.length == 1) {
        //          this.property.townId = this.properties[0].townId;
        //          this.property.townStr = this.properties[0].townStr;
        //          this.property.townshipId = this.properties[0].townshipId;
        //          this.property.townshipStr = this.properties[0].townshipStr;
        //          this.property.propertyId = this.properties[0].propertyId;
        //          this.property.propertyAddress = this.properties[0].propertyAddress;
        //          this.property.propertyBuldingName = this.properties[0].propertyBuldingName;
        //          this.property.propertyReference = this.properties[0].propertyReference;
        //          this.property.propertyOldKey = this.properties[0].propertyOldKey;
        //          this.property.propertyPlotNumber = this.properties[0].propertyPlotNumber;
        //          this.property.tenantCustomerKey = this.properties[0].tenantCustomerKey;
        //          this.property.tenantName = this.properties[0].tenantName;
        //          this.property.tenantIdNumber = this.properties[0].tenantIdNumber;
        //          this.property.tenantTelephoneNumber = this.properties[0].tenantTelephoneNumber;
        //          this.property.tenantCellPhoneNumber = this.properties[0].tenantCellPhoneNumber;
        //          this.property.propertyOwnerCustomerKey = this.properties[0].propertyOwnerCustomerKey;
        //          this.property.propertyOwnerName = this.properties[0].propertyOwnerName;
        //          this.property.propertyOwnerIdNumber = this.properties[0].propertyOwnerIdNumber;
        //          this.property.propertyOwnerTelephoneNumber = this.properties[0].propertyOwnerTelephoneNumber;
        //          this.property.propertyOwnerCellPhoneNumber = this.properties[0].propertyOwnerCellPhoneNumber;
        //          this.property.ownerShare = this.properties[0].ownerShare;
        //        }
        //      }
        //      this.$root.$emit('datagrid_updated');
        //    }
        //    else {
        //      this.$alertMsg(response.data.data.text);
        //    }
        //    loader.hide();
        //  })
        //  .catch(error => {
        //    loader.hide();
        //   this.$alertMsg(error.response.statusText);
        //  });
      }
    },
    onSelectProperty(info) {
      if (info.newRowIndex < 0) return;

      var prop = info.data;
      if (prop === null || prop === undefined) return;

      this.dataObj.property = prop;
    },
    fillPropertiesCols() {
      this.propertiesCols.push({
        dataField: "propertyReference",
        caption: this.$t("activities.propertyReference"),
      });
      this.propertiesCols.push({
        dataField: "tenantCustomerKey",
        caption: this.$t("activities.propertyTenant"),
      });
      this.propertiesCols.push({
        dataField: "propertyOwnerCustomerKey",
        caption: this.$t("activities.propertyOwner"),
      });
      this.propertiesCols.push({
        dataField: "ownerShare",
        caption: this.$t("activities.ownerShare"),
      });
      this.propertiesCols.push({
        dataField: "propertyOldKey",
        caption: this.$t("activities.propertyOldKey"),
      });
      this.propertiesCols.push({
        dataField: "propertyPlotNumber",
        caption: this.$t("activities.plotNumber"),
      });
      //this.propertiesCols.push({ dataField: 'propertyOwnerName', caption: this.$t('activities.customerName') });
      this.propertiesCols.push({
        dataField: "tenantTelephoneNumber",
        caption: this.$t("activities.telNo"),
      });
      this.propertiesCols.push({
        dataField: "tenantIdNumber",
        caption: this.$t("activities.idNo"),
      });
      this.propertiesCols.push({
        dataField: "propertyAddress",
        caption: this.$t("activities.address"),
      });
      this.propertiesCols.push({
        dataField: "propertyBuldingName",
        caption: this.$t("activities.buildingName"),
      });
      this.propertiesCols.push({
        dataField: "propertyOwnerName",
        caption: this.$t("activities.ownerName"),
      });
      this.propertiesCols.push({
        dataField: "propertyOwnerIdNumber",
        caption: this.$t("activities.ownerIdNo"),
      });
      this.propertiesCols.push({
        dataField: "propertyOwnerTelephoneNumber",
        caption: this.$t("activities.ownerTelNo"),
      });
      this.propertiesCols.push({
        dataField: "propertyOwnerCellPhoneNumber",
        caption: this.$t("activities.ownerCellPhone"),
      });
    },
    completeTask() {
      this.dataObj.completeTask();
    },
    fillFiltersObj() {
      this.filterObj.push({
        defaultIndex: 0,
        index: 0,
        field: "townId",
        fieldDesc: this.$t("activities.town"),
        type: "list",
        listSource: this.dataObj.towns,
        listValueField: "value",
        listTextField: "text",
        addedDefault: false,
        defaultValue: "-1",
        value: "-1",
        added: false,
      });

      this.filterObj.push({
        defaultIndex: 1,
        index: 1,
        field: "townshipId",
        fieldDesc: this.$t("activities.township"),
        type: "list",
        listSource: this.dataObj.townships,
        listValueField: "value",
        listTextField: "text",
        addedDefault: false,
        defaultValue: "-1",
        value: "-1",
        added: false,
      });

      this.filterObj.push({
        defaultIndex: 2,
        index: 2,
        field: "propertyReference",
        fieldDesc: this.$t("activities.propertyReference"),
        type: "text",
        addedDefault: true,
        defaultValue: "",
        value: "",
        added: true,
      });

      this.filterObj.push({
        defaultIndex: 3,
        index: 3,
        field: "propertyPlotNumber",
        fieldDesc: this.$t("activities.propertyPlotNumber"),
        type: "text",
        addedDefault: false,
        defaultValue: "",
        value: "",
        added: false,
      });

      this.filterObj.push({
        defaultIndex: 4,
        index: 4,
        field: "propertyBuldingName",
        fieldDesc: this.$t("activities.propertyBuldingName"),
        type: "text",
        addedDefault: false,
        defaultValue: "",
        value: "",
        added: false,
      });

      this.filterObj.push({
        defaultIndex: 5,
        index: 5,
        field: "propertyAddress",
        fieldDesc: this.$t("activities.propertyAddress"),
        type: "text",
        addedDefault: false,
        defaultValue: "",
        value: "",
        added: false,
      });

      this.filterObj.push({
        defaultIndex: 6,
        index: 6,
        field: "propertyOwnerCustomerKey",
        fieldDesc: this.$t("activities.propertyOwnerCustomerKey"),
        type: "text",
        addedDefault: true,
        defaultValue: "",
        value: "",
        added: true,
      });

      this.filterObj.push({
        defaultIndex: 7,
        index: 7,
        field: "propertyOwnerName",
        fieldDesc: this.$t("activities.propertyOwnerName"),
        type: "text",
        addedDefault: false,
        defaultValue: "",
        value: "",
        added: false,
      });

      this.filterObj.push({
        defaultIndex: 8,
        index: 8,
        field: "propertyOwnerIdNumber",
        fieldDesc: this.$t("activities.propertyOwnerIdNumber"),
        type: "text",
        addedDefault: false,
        defaultValue: "",
        value: "",
        added: false,
      });

      this.filterObj.push({
        defaultIndex: 9,
        index: 9,
        field: "propertyOwnerTelephoneNumber",
        fieldDesc: this.$t("activities.propertyOwnerTelephoneNumber"),
        type: "text",
        addedDefault: false,
        defaultValue: "",
        value: "",
        added: false,
      });
    },
  },
};
